import { Button, Paper, Text } from "@mantine/core";
import { getRatingChangeLastXAttempts } from "./statsUtils";
import { IconTrendingDown, IconTrendingUp } from "@tabler/icons-react";
import { OtPosition } from "./PositionStats";
import { useNavigate } from "react-router-dom";
import { EQUALIBRIUM, MISTAKE_DELTA } from "./utils";
import { useMistakesStorage } from "./ZustandState";
import { useMediaQuery } from "@mantine/hooks";

interface Props {
    opening: OtPosition;
}

const PaperBlocks: React.FC<Props> = ({ opening }) => {
    const navigate = useNavigate();
    const mistakesStorage = useMistakesStorage((state) => state);
    const isMobile = useMediaQuery("(max-width: 900px)");

    const highestRating = Math.max(
        ...opening.OtAttempt2.map((attempt) => {
            return parseInt(attempt.positionRating as string) + parseInt(attempt.ratingGain);
        })
    );

    const ratingChangeLast20 = getRatingChangeLastXAttempts(opening.OtAttempt2, 20);
    const ratingChangeLast50 = getRatingChangeLastXAttempts(opening.OtAttempt2, 50);

    const mistakeAttempts = opening.OtAttempt2.filter(
        (attempt) =>
            (attempt.playerColor === "w" && parseFloat(attempt.evaluation) <= EQUALIBRIUM - MISTAKE_DELTA) ||
            (attempt.playerColor === "b" && parseFloat(attempt.evaluation) >= EQUALIBRIUM + MISTAKE_DELTA)
    );

    return (
        <div className="space-y-8">
            <Paper p="md" withBorder radius="md" w={isMobile ? "370px" : "320px"} h="150px">
                <div className="flex items-center flex-col space-y-3">
                    <div>
                        <Text className="uppercase" size="xs" c="dimmed">
                            Current
                        </Text>
                        <div className="flex items-center space-x-1">
                            <Text size="xl" mt="-4px" className="font-bold">
                                {opening.rating}
                            </Text>
                        </div>
                    </div>
                    <div>
                        <Text className="uppercase" size="xs" c="dimmed">
                            Highest
                        </Text>
                        <div className="flex items-center space-x-1">
                            <Text size="xl" mt="-4px" className="font-bold">
                                {highestRating}
                            </Text>
                        </div>
                    </div>
                </div>
            </Paper>
            <Paper p="md" withBorder radius="md" w={isMobile ? "370px" : "320px"} h="150px">
                <div className="flex items-center flex-col space-y-3 justify-center h-full">
                    <div>
                        <Text className="uppercase" size="xs" c="dimmed">
                            Last 20 games
                        </Text>
                        <div className="flex items-center space-x-1">
                            {ratingChangeLast20 >= 0 ? (
                                <IconTrendingUp color="#69db7c" />
                            ) : (
                                <IconTrendingDown color="#ff8787" />
                            )}
                            <Text
                                size="xl"
                                mt="-4px"
                                className="font-bold"
                                c={ratingChangeLast20 >= 0 ? "green" : "red"}
                            >
                                {ratingChangeLast20 >= 0 ? "+" : ""}
                                {ratingChangeLast20}
                            </Text>
                        </div>
                    </div>
                    <div>
                        <Text className="uppercase" size="xs" c="dimmed">
                            Last 50 games
                        </Text>
                        <div className="flex items-center space-x-1">
                            {ratingChangeLast50 >= 0 ? (
                                <IconTrendingUp color="#69db7c" />
                            ) : (
                                <IconTrendingDown color="#ff8787" />
                            )}

                            <Text
                                size="xl"
                                mt="-4px"
                                className="font-bold"
                                c={ratingChangeLast50 >= 0 ? "green" : "red"}
                            >
                                {ratingChangeLast50 >= 0 ? "+" : ""}
                                {ratingChangeLast50}
                            </Text>
                        </div>
                    </div>
                </div>
            </Paper>
            <div className="flex flex-col space-y-3">
                <Button
                    variant="filled"
                    onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/?position=${opening.id}`);
                    }}
                >
                    Play
                </Button>
                <Button
                    variant="outline"
                    onClick={(e) => {
                        e.stopPropagation();
                        mistakesStorage.setCurrentIndex(0);
                        mistakesStorage.setMistakeAttempts(mistakeAttempts);
                        navigate(`/?mistakes=${opening.id}`);
                    }}
                >
                    Train weakest lines ({mistakeAttempts.length})
                </Button>
            </div>
        </div>
    );
};

export default PaperBlocks;
